/**
 * @module Loyality 
 *  Apis must need auth details to trigger url - NormalApi
 */

 import store from '@/store/store';
 import Env from '@/env';
 import NormalApi from '@/Components/Controllers/NormalApis';
 import Helpers from '@/Components/Helpers/Helpers';

 
 export default {
    /**
    * Register user to loyality
    */
    registerToLoyality(user_id, business_id, referral_key = '') {
      let data = {
        business_id,
      };
      // if we have referral key insert
      if(referral_key){
        data.referral_key = referral_key;
      }
      const url= `${Env.loginUrl}/api/v1/users/${user_id}/register_loyalty`;
      return NormalApi.postApi(url, {
        'api-token': Env.loyality.api_token
      }, data)
      .then(res => res)
      .catch(err => err);
    },

    /**
    * Register user to loyality with referral_key
    */
    registerToLoyaltyViaReferral(user_id, business_id, referral_key) {
      const url= `${Env.loginUrl}/api/v1/users/${user_id}/register_loyalty`;
      return NormalApi.postApi(url, {
        'api-token': Env.loyality.api_token
      }, {
        business_id,
        referral_key
      })
      .then(res => res)
      .catch(err => err);
    },
    
    /**
    * validate shared referral key
    */
    validateLoyaltyReferralKey(business_id, referral_key) {
      const url= `${Env.loginUrl}/api/v1/users/business/${business_id}/referral/loyalty_validate`;
      return NormalApi.postApi(url, {
        'api-token': Env.loyality.api_token
      }, {
        referral_key
      })
      .then(res => res)
      .catch(err => err);
    },

    /**
    * Get user loyality details
    */
     getUserLoyality(user_id, business_id) {
      const url= `${Env.loginUrl}/api/v1/users/${user_id}/business/${business_id}/loyalty`;
      return NormalApi.getApi(url, {
      'api-token': Env.loyality.api_token
      })
      .then(res => res)
      .catch(err => err);
    },


} 